export default __webpack_public_path__ + "resources/icons/n310-4921.png";